import React from 'react';
import '../Styles/bottomNav.css';

const BottomNav = () => {
    return (
        <section className='footer'>
            <p>Made with 💖 by Abhi Jain</p>
            <div className='socio'>
                <a href="https://www.linkedin.com/in/abhi-jain-1b42421ba/" >Linkedin</a>
                <a href="https://twitter.com/abhiwd" >Twitter</a>
                <a href="https://github.com/abhijain2003" >Github</a>
            </div>
        </section>
    )
}

export default BottomNav;